<template>
    <div class="vehicle-form__item vehicle-form__item--select">
        <!-- <input type="text" id="search" v-model="searchStr" placeholder="Search Model" class="form-control" >
        <ul v-if="searchModels.length && openDD === true" class="vehicle-dropdown">
            <li v-for="model in searchModels" :key="model.model"  @click.prevent="selectModel(model)" class="">
                <a href="#" class="notranslate">{{ model.desc }}</a>
            </li>
        </ul> -->
        <!-- <select class="form-control" aria-label="Brand"></select> -->
        <input :list="'dlist_'+ elemid" name="inptdl-model" id="inptdl-model" v-model="searchStr" @change.prevent="dlist_selected($event.target.value)" placeholder="Search Model" class="form-control" />
        <datalist :id="'dlist_' + elemid">
            <option v-for="model in _models" :value="model.desc" :key="model.model" class="" >{{model.desc}}</option>
        </datalist>
    </div>
</template>

<script>
    import VehicleSearch from '../../../mixins/vehicle_search.js';

    export default {
        mixins: [VehicleSearch],
        props: {
            elemid: {
                type: String,
                required: true,
            },
            _models: {
                type: Array,
                required: true,
            },
        },
        watch: {
            searchStr() {
                this.openDD = true;
                this.model_autosel = false;
            },
        },
        data() {
            return {
                searchStr: '',
                openDD: true,
                model_autosel: false,
                // searchModels: [],
            }
        },

        computed: {
            searchModels() {
                if (this.searchStr === '' || this.model_autosel == true) {
                    return [];
                }
                
                let matches = 0
                const mods = this._models.filter(row => {
                    if (row.model.toLowerCase().includes(this.searchStr.toLowerCase()) && matches < 10) {
                        matches++
                        return row;
                    }
                });

                return mods;
            }
        },

        emits: ['model_selected', 'error_sel'],

        methods: {
            selectModel(model) {
                this.searchStr = model.model;
                this.openDD = false;
                this.model_autosel = true;
                this.$emit('model_selected', model);
            },

            dlist_selected(sel) {
                const model = this._models.find(m => m.model == sel);
                
                if(model != undefined){
                    this.$emit('model_selected', model);
                }else{
                    // alert('Please select from the options.');
                    this.$emit('error_sel');
                }
                
            },

            clearInput() {
                this.searchStr = '';
            }
        }
    }
</script>

<style scoped>
    .vehicle-dropdown{
        position: absolute;
        z-index: 1000;
        float: left;
        min-width: 188px;
        padding: 5px 0;
        margin: 2px 0 0;
        font-size: 14px;
        text-align: left;
        list-style: none;
        background-color: #fff;
        -webkit-background-clip: padding-box;
                background-clip: padding-box;
        border: 1px solid #ccc;
        border: 1px solid rgba(0, 0, 0, .15);
        border-radius: 4px;
        -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, .175);
                box-shadow: 0 6px 12px rgba(0, 0, 0, .175);
    }

    .vehicle-dropdown.pull-right {
    right: 0;
    left: auto;
    }
    .vehicle-dropdown .divider {
    height: 1px;
    margin: 9px 0;
    overflow: hidden;
    background-color: #e5e5e5;
    }
    .vehicle-dropdown > li > a {
    display: block;
    padding: 3px 20px;
    clear: both;
    font-weight: normal;
    line-height: 1.42857143;
    color: #333;
    white-space: nowrap;
    }
    .vehicle-dropdown > li > a:hover,
    .vehicle-dropdown > li > a:focus {
    color: #262626;
    text-decoration: none;
    background-color: #f5f5f5;
    }

    .vehicle-dropdown > li > a:hover, .vehicle-dropdown > li > a:focus {
        color: #fff;
        text-decoration: none;
        background-color: #337ab7;
    }

    .vehicle-dropdown > .active > a,
    .vehicle-dropdown > .active > a:hover,
    .vehicle-dropdown > .active > a:focus {
    color: #fff;
    text-decoration: none;
    background-color: #337ab7;
    outline: 0;
    }
    .vehicle-dropdown > .disabled > a,
    .vehicle-dropdown > .disabled > a:hover,
    .vehicle-dropdown > .disabled > a:focus {
    color: #777;
    }
    .vehicle-dropdown > .disabled > a:hover,
    .vehicle-dropdown > .disabled > a:focus {
    text-decoration: none;
    cursor: not-allowed;
    background-color: transparent;
    background-image: none;
    filter: progid:DXImageTransform.Microsoft.gradient(enabled = false);
    }
    .open > .vehicle-dropdown {
    display: block;
    }
    .open > a {
    outline: 0;
    }
</style>